import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Loading from "components/commons/Loading";
import PageLayout from "components/layout/PageLayout";
import MonthPicker from "components/widget/MonthPicker";
import { useLazyGetCostRefundReportQuery } from "../costRefund/api/costRefundApiSlice";
import CostRefundReport from "../costRefund/components/CostRefundReport";
import OvertimeReportTable from "../overtime/views/OvertimeReportTable";
import { useLazyGetAbsenceStatsQuery } from "./api/absenceReportApiSlice";
import AbsenceReportTables from "./components/AbsenceReportTable";
import AbsenceRequestDetailTable from "./components/AbsenceRequestDetailTable";


const AbsenceReport = () => {

    const [t] = useTranslation(["absenceReport"])
    const [month, setMonth] = useState('')


    useEffect(() => {
        console.log(`Month changed ! ${month}`)

        if (month) {
            const year = month.split("-")[0]
            const currentMonth = parseInt(month.split("-")[1])

            const firstDay = getFirstDayOfMonth(year, currentMonth);
            const lastDay = getLastDayOfMonth(year, currentMonth,);
            const today = new Date()

            const startEpoch = Math.round(firstDay.getTime() / 1000)
            const endEpoch = Math.round(lastDay.getTime() / 1000)
            const todayEpoch = Math.round(today.getTime() / 1000)


            console.log(`START: ${firstDay} \n Long ${startEpoch}`)
            console.log(`END: ${lastDay} \n Long ${endEpoch}`)
            console.log(`NOW: ${today}  \n Long ${todayEpoch}`)


            trigger({ start: startEpoch, end: endEpoch })
            queryCostRefundsReport({ start: startEpoch, end: endEpoch })
        }

    }, [month])

    const [trigger, {
        data: absenceReportsUi,
        isLoading,
        isSuccess,
        isFetching,
        isError,
        error,
        refetch
    }] = useLazyGetAbsenceStatsQuery()

    const [queryCostRefundsReport, {
        data: costRefundReportUi,
        isLoading: costRefundIsLoading,
        isSuccess: costRefundIsSuccess,
        isFetching: costRefundIsFetching,
        isError: costRefundIsIsError
    }] = useLazyGetCostRefundReportQuery()

    let startEpoch
    let endEpoch


    if (month) {
        const year = month.split("-")[0]
        const currentMonth = parseInt(month.split("-")[1])

        const firstDay = getFirstDayOfMonth(year, currentMonth);
        const lastDay = getLastDayOfMonth(year, currentMonth,);

        startEpoch = Math.round(firstDay.getTime() / 1000)
        endEpoch = Math.round(lastDay.getTime() / 1000)
    }


    return <PageLayout
        pageTitle={t("absenceReport:menu.absence_report")}
        bodyContent={
            <>
                <div className="container">
                    <MonthPicker
                        month={month}
                        onMonthPicked={setMonth}
                    />
                </div>

                {isSuccess && isFetching === false &&
                    <div className="container">
                        <AbsenceReportTables startDate={startEpoch} endDate={endEpoch} absenceRecords={absenceReportsUi.aggregateData} />
                        {
                            costRefundIsSuccess &&
                            <CostRefundReport costRefundReportUi={costRefundReportUi} />
                        }

                        <AbsenceRequestDetailTable absenceRequest={absenceReportsUi.absences} />
                        <OvertimeReportTable overtimes={absenceReportsUi.overtimes} />

                    </div>
                }



                {isFetching &&
                    <section className="text-center">
                        <Loading />
                    </section>
                }

            </>
        } />


}


export default AbsenceReport

function sortByDate(a, b) {
    return a.startDate - b.startDate
}

function getFirstDayOfMonth(year, month) {
    return new Date(year, month - 1, 1);
}

function getLastDayOfMonth(year, month) {
    const date = new Date(year, month, 1)
    date.setSeconds(-1)
    return date
}